import { useEffect, useState } from "react";
import { renderRasterLayer3D, renderTerrain, renderVectorLayer3D, TileMapLayer, renderVectorLayer, renderRasterLayer, TileMapLayer2D } from "./renderLayerService";
import DeckGL, { MapController } from "deck.gl";
import 'mapbox-gl/dist/mapbox-gl.css';
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Legend } from 'recharts';
import ReactDOMServer from 'react-dom/server';
import { InfoCircleOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import "./SingleLayerDeckGL.css";
import { ZoomInOutlined, DragOutlined } from "@ant-design/icons";
import { Progress } from "antd";
import { Map } from 'react-map-gl';
import maplibregl from 'maplibre-gl';

function getTooltip({ object }) {

    const { Text } = Typography;

    const tooltipStyle = {
        backgroundColor: '#000b27',
        borderRadius: '20px',
        border: '4px #ffffff9c solid',
        boxShadow: '6px 0 16px 0 rgba(0, 0, 0, 0.08), 3px 0 6px -4px rgba(0, 0, 0, 0.12), 9px 0 28px 8px rgba(0, 0, 0, 0.05)'
    }

    if (object?.properties?.layerName === "accessibility-buildings-sumatra") {
        return {
            html: `\
                <div style="display: table">
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Education average accessibility by foot:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.foot_education_m} </div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Education average accessibility by bicycle:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.bicycle_education_m} </div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Education average accessibility by car:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.car_education_m} </div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Transport average accessibility by foot:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.foot_Transport} </div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Transport average accessibility by bicycle:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.bicycle_transport_m} </div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Transport average accessibility by car:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.car_transport_m} </div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Healthcare average accessibility by foot:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.foot_healthcare_m} </div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Healthcare average accessibility by bicycle:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.bicycle_healthcare_m} </div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Healthcare average accessibility by car:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.car_healthcare_m} </div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Average accessibility by foot:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.foot_average_m} </div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Average accessibility by bicycle:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.bicycle_average_m} </div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Average accessibility by car:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.car_average_m} </div>
                    </div>
                </div>
      `,
            style: tooltipStyle
        }
    }

    if (object?.properties?.layerName === "commuting-admins-indonesia") {
        return {
            html: `\
                <div style="display: table">
                    <h1 style="font-size: 24px">${object.properties.NAME}</h1>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Day population:</div>
                        <div style="display: table-cell; padding: 5px">${Math.round(object.properties.day_population)}</div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Night population:</div>
                        <div style="display: table-cell; padding: 5px">${Math.round(object.properties.night_population)}</div>
                    </div>
                </div>
      `,
            style: tooltipStyle
        }
    }



    /*if (object?.properties?.layerName === "uhi-sumatra") {
        return {
            html: `\
                <div style="display: table">
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Mean difference:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.d_mean.toFixed(2)}°C</div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Median difference:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.d_median.toFixed(2)}°C</div>
                    </div>
                </div>
      `
        }
    }*/

    if (object?.properties?.layerName === "roads-indonesia") {
        return {
            html: `\
                <div style="display: table">
                    <div style="display: table-row">
                        <div style="display: table-cell; padding: 5px">Name:</div>
                        <div style="display: table-cell; padding: 5px"> ${object.properties.name}</div>
                    </div>
                </div>
      `,
            style: tooltipStyle
        }
    }

    //if (object?.properties?.layerName === "administrative-bounds-indonesia") {
    //    return {
    //        html: `\
    //            <div style="display: table">
    //                <div style="display: table-row;">
    //                    <div style="display: table-cell; padding: 5px">Name:</div>
    //                    <div style="display: table-cell; padding: 5px">${(object.properties.NAME)}</div>
    //                </div>
    //            </div>
    //  `,
    //        style: tooltipStyle
    //    }
    //}


    if (object?.properties?.layerName === "subsidence-buildings-sumatra") {
        return {
            html: `\
                <div style="display: table">
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Inspection priority score:</div>
                        <div style="display: table-cell; padding: 5px">${Math.round(object.properties.inspection_priority_score * 100) / 100} </div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Velocity asc:</div>
                        <div style="display: table-cell; padding: 5px">${Math.round(object.properties.feature_vel_asc)} mm/yr</div>
                    </div>
                    <div style="display: table-row">
                        <div style="display: table-cell; padding: 5px">Velocity desc:</div>
                        <div style="display: table-cell; padding: 5px">${Math.round(object.properties.feature_vel_desc)} mm/yr</div>
                    </div>
                    <div style="display: table-row">
                        <div style="display: table-cell; padding: 5px">Mean differencial velocity asc:</div>
                        <div style="display: table-cell; padding: 5px"> ${Math.round(object.properties.mean_diff_vel_asc)}</div>
                    </div>
                    <div style="display: table-row">
                        <div style="display: table-cell; padding: 5px">Mean differencial velocity desc:</div>
                        <div style="display: table-cell; padding: 5px">${Math.round(object.properties.mean_diff_vel_desc)}</div>
                    </div>
                </div>
      `,
            style: tooltipStyle
        }
    }

    if (object?.properties?.layerName === "morphology-buildings-sumatra") {
        return {
            html: `\
                <div style="display: table">
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Covered Area Ratio:</div>
                        <div style="display: table-cell; padding: 5px; text-align: right">${Math.round(object.properties.sicCAR * 100) / 100} </div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Floor Area Ratio:</div>
                        <div style="display: table-cell; padding: 5px; text-align: right">${Math.round(object.properties.sicFAR * 100) / 100} </div>
                    </div>
                    <div style="display: table-row">
                        <div style="display: table-cell; padding: 5px">Building Volume:</div>
                        <div style="display: table-cell; padding: 5px; text-align: right">${Math.round(object.properties.sdbVol * 100) / 100} </div>
                    </div>
                    <div style="display: table-row">
                        <div style="display: table-cell; padding: 5px">Shared Wall Ratio:</div>
                        <div style="display: table-cell; padding: 5px; text-align: right">${Math.round(object.properties.mtbSWR * 100) / 100} </div>
                    </div>
                    <div style="display: table-row">
                        <div style="display: table-cell; padding: 5px">Building Solar orientation:</div>
                        <div style="display: table-cell; padding: 5px; text-align: right">${Math.round(object.properties.licGDe * 100) / 100} </div>
                    </div>
                    <div style="display: table-row">
                        <div style="display: table-cell; padding: 5px">Building-to-Street alignment:</div>
                        <div style="display: table-cell; padding: 5px; text-align: right">${Math.round(object.properties.stbAli * 100) / 100} </div>
                    </div>
                    <div style="display: table-row">
                        <div style="display: table-cell; padding: 5px">Building-to-Building Alignment:</div>
                        <div style="display: table-cell; padding: 5px; text-align: right">${Math.round(object.properties.mtbAli * 100) / 100} </div>
                    </div>
                </div>
      `,
            style: tooltipStyle
        }
    }

    if (object?.properties?.layerName === "IDN") {
        return {
            html: `\
                <div style="display: table">
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Area:</div>
                        <div style="display: table-cell; padding: 5px">${Math.round(object.properties.area)} m<sup>2</sup></div>
                    </div>
                </div>
      `,
            style: tooltipStyle
        }
    }

    if (object?.properties?.layerName === "buildings") {
        return {
            html: `\
                <div style="display: table">
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Height:</div>
                        <div style="display: table-cell; padding: 5px">${Math.round(object.properties.height * 100) / 100} m </div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Area:</div>
                        <div style="display: table-cell; padding: 5px">${Math.round(object.properties.area)} m<sup>2</sup></div>
                    </div>
                    <div style="display: table-row">
                        <div style="display: table-cell; padding: 5px">Population:</div>
                        <div style="display: table-cell; padding: 5px">${Math.round(object.properties.population)}</div>
                    </div>
                    <div style="display: table-row">
                        <div style="display: table-cell; padding: 5px">Building type:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.resident === true ? "residential" : "non residential"}</div>
                    </div>
                </div>
      `,
            style: tooltipStyle
        }
    }

    if (object?.properties?.layerName === "psinsar") {
        return {
            html: `\
                <div style="display: table">
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">LOS (Line of sight) acceleration:</div>
                        <div style="display: table-cell; padding: 5px">${(object.properties.acl_los).toFixed(2)} mm/year^2</div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">LOS seasonal component amplitude:</div>
                        <div style="display: table-cell; padding: 5px">${(object.properties.sea_los).toFixed(2)} mm</div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">Long period coherence:</div>
                        <div style="display: table-cell; padding: 5px">${(object.properties.coh).toFixed(2)} </div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">LOS displacement mean standard deviation:</div>
                        <div style="display: table-cell; padding: 5px">${(object.properties.d_std_los).toFixed(2)} </div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">LOS velocity:</div>
                        <div style="display: table-cell; padding: 5px">${(object.properties.v_los).toFixed(2)} mm/year</div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">LOS velocity standard deviation:</div>
                        <div style="display: table-cell; padding: 5px">${(object.properties.v_los_std).toFixed(2)} mm/year</div>
                    </div>
                    <div style="display: table-row;">
                        <div style="display: table-cell; padding: 5px">uid:</div>
                        <div style="display: table-cell; padding: 5px">${object.properties.uid} </div>
                    </div>
                </div>
      `,
            style: tooltipStyle
        }
    }

    if (object?.properties?.layerName === "administrative-bounds-indonesia") {
        const level = object.properties.level;
        //console.log(object.properties)
        const names = ['NAME_1', 'NAME_2', 'NAME_3', 'NAME_4']
        const levelName = ['Province', 'Regency', 'District', 'Village']
        const displayNames = names.slice(0, level)
        let background = null

        const renderLineChart = (
            <div style={{ display: 'table' }}>
                <div style={{ display: 'flex', flexDirection: 'column', padding: '5px', justifyContent: 'center', alignItems: 'center' }}>
                    {displayNames.map((displayName, index) => (
                        <div style={{ display: 'table-row' }}>
                            {level === index + 1 && level != 1 ?
                                <div style={{ fontWeight: 'bold' }}>
                                    <div style={{ display: 'table-cell', padding: '5px' }}>{levelName[index]}:</div>
                                    <div style={{ display: 'table-cell', padding: '5px' }}>{(object.properties[displayName])}</div>
                                </div>
                                :
                                <div style={{ display: 'table-row' }}>
                                    <div style={{ display: 'table-cell', padding: '5px' }}>{levelName[index]}:</div>
                                    <div style={{ display: 'table-cell', padding: '5px' }}>{(object.properties[displayName])}</div>
                                </div>
                            }
                        </div>
                    ))}
                    {level != 4 ?
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>

                            <InfoCircleOutlined style={{ padding: '3px', fontSize: '12px' }} />
                            <Text type='secondary' style={{ fontSize: '12px' }}> zoom in to see {levelName[level]}</Text>
                        </div>
                        :
                        null}
                </div>
            </div>
        );

        const lineChartHtml = ReactDOMServer.renderToString(renderLineChart);

        return {
            html: `\
                ${lineChartHtml}
                `
            ,
            style: tooltipStyle
        }
    }


    if (object?.properties?.layerName === "urban-heat-islands-indonesia" || object?.properties?.layerName === "urban-heat-islands-day-indonesia") {
        const MonthlyTemperatures = [
            { month: 'jan', urban: object.properties.u_january, rural: object.properties.r_january },
            { month: 'feb', urban: object.properties.u_february, rural: object.properties.r_february },
            { month: 'mar', urban: object.properties.u_march, rural: object.properties.r_march },
            { month: 'apr', urban: object.properties.u_april, rural: object.properties.r_april },
            { month: 'may', urban: object.properties.u_may, rural: object.properties.r_may },
            { month: 'jun', urban: object.properties.u_june, rural: object.properties.r_june },
            { month: 'jul', urban: object.properties.u_july, rural: object.properties.r_july },
            { month: 'aug', urban: object.properties.u_august, rural: object.properties.r_august },
            { month: 'sep', urban: object.properties.u_september, rural: object.properties.r_september },
            { month: 'oct', urban: object.properties.u_october, rural: object.properties.r_october },
            { month: 'nov', urban: object.properties.u_november, rural: object.properties.r_november },
            { month: 'dec', urban: object.properties.u_december, rural: object.properties.r_december },]

        const renderLineChart = (
            <LineChart width={600} height={200} data={MonthlyTemperatures} style={{ paddingTop: '20px' }}>
                <Line type="monotone" dataKey="urban" stroke="#ff9900" strokeWidth={3} />
                <Line type="monotone" dataKey="rural" stroke="#00ffff" strokeWidth={3} />
                <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
                <XAxis stroke="#ffffff" dataKey="month" />
                <YAxis stroke="#ffffff" />
                <Legend verticalAlign="top" />
            </LineChart>
        );
        const lineChartHtml = ReactDOMServer.renderToString(renderLineChart);
        return {
            html: `\
                <div style="display: flex; width: 650px; height: 250px;  justify-content: center; align-items: center; padding: 0; margin: 0;">
                    <div style="display: flex; width: 100%; height: 100%;  background-color: #000b27; padding-right: 50px; margin: 0; justify-content: center; align-items: center; border-radius: 40px;">
                        ${lineChartHtml}
                    </div>
                </div>
                `
            ,
            style: tooltipStyle
        }
    }



    return (
        object && {
            html: `\
                `
        }
    );
}

export function SingleLayerDeckGL({
    data,
    viewState,
    setViewState,
    initViewState,
    isView3d,
    mapTheme,
    colorMapName,
    colorMapOpacity,
}) {
    const [layer, setLayer] = useState([]);
    let blurZoom = 5.5;
    const initialZoom = initViewState?.zoom
    const MAPTILER_API_KEY = window.__env__?.REACT_APP_MAPTILER_TOKEN ?? process.env.REACT_APP_MAPTILER_TOKEN
    const mapTheme2D = mapTheme.split('/')[0];
    const MAP_STYLE = `https://api.maptiler.com/maps/${mapTheme2D}/style.json?key=${MAPTILER_API_KEY}`;



    function getLayers(isView3d, data, colorMapName, mapTheme, colorMapOpacity) {
        const layers = [];

        if (isView3d) {
            layers.push(renderTerrain(isView3d));
            layers.push(TileMapLayer(mapTheme));
        }

        if (data['is_raster'] && isView3d) {
            layers.push(renderRasterLayer3D({ data: data, colorMapName: colorMapName, colorMapOpacity: colorMapOpacity, zoom: viewState.zoom }));
        } else if (data['is_raster'] && !isView3d) {
            layers.push(renderRasterLayer({ data: data, colorMapName: colorMapName, colorMapOpacity: colorMapOpacity, zoom: viewState.zoom }));
        } else if (!data['is_raster'] && isView3d) {
            layers.push(renderVectorLayer3D({ data: data, colorMapName: colorMapName, colorMapOpacity: colorMapOpacity, zoom: viewState.zoom }));
        } else {
            layers.push(renderVectorLayer({ data: data, colorMapName: colorMapName, colorMapOpacity: colorMapOpacity, zoom: viewState.zoom }));
        }

        return layers;
    }

    useEffect(() => {
        data && setLayer(getLayers(isView3d, data, colorMapName, mapTheme, colorMapOpacity))
    }, [data, isView3d, colorMapName, mapTheme, colorMapOpacity, viewState]);

    useEffect(() => {


        setViewState({
            ...viewState,
            pitch: isView3d ? 60 : 0,
            transitionDuration: 400,
        })

    }, [isView3d]);



    if (data?.id == 14) {
        blurZoom = 5.5;
    }
    else if (data?.id == 11) {
        blurZoom = 7.5;
    }

    if ((data?.id == 14 || data?.id == 11) && viewState.zoom < blurZoom) {
        let blur = (blurZoom - viewState.zoom) / (blurZoom - initialZoom)
        return (
            <div className="container">
                <div className="disclaimer-progress">
                    <div className="disclaimer"><ZoomInOutlined style={{ padding: '5px' }} /> Zoom and <DragOutlined style={{ padding: '5px' }} /> drag to see more details</div>
                    <Progress percent={(100 - blur * 100).toFixed(0)} showInfo={false} strokeColor={'#ffb649'} style={{ width: '100%' }} />
                </div>
                <DeckGL
                    style={{ filter: `blur(${blur * 8 + 2}px)` }}
                    controller={{ type: MapController }}
                    initialViewState={viewState}
                    onViewStateChange={({ viewState }) => setViewState(viewState)}
                    getTooltip={getTooltip}
                    layers={layer}>
                        <Map
                            reuseMaps
                            mapLib={maplibregl}
                            mapStyle={MAP_STYLE}
                            preventStyleDiffing={true}
                            initialViewState={viewState}
                            attributionControl={true}
                        />
                </DeckGL>
            </div>
        )
    }
    else {
        return (
            <>
                <DeckGL
                    controller={{ type: MapController }}
                    initialViewState={viewState}
                    onViewStateChange={({ viewState }) => setViewState(viewState)}
                    getTooltip={getTooltip}
                    layers={layer}>

                    <Map
                        reuseMaps
                        mapLib={maplibregl}
                        mapStyle={MAP_STYLE}
                        preventStyleDiffing={true}
                        initialViewState={viewState}
                        attributionControl={true}
                    />

                </DeckGL>

            </>
        )
    }
} 